if (!customElements.get('hh-buy')) {
  customElements.define(
    'hh-buy',
    class HhBuy extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hh-buy__track');
        this.slides = Array.from(this.querySelectorAll('.hh-buy__slide'));
        this.thumbs = Array.from(this.querySelectorAll('.hh-buy__thumb'));
        this.dots = Array.from(this.querySelectorAll('.hh-buy__dot'));
        this.prev = this.querySelector('.hh-buy__arrow--prev');
        this.next = this.querySelector('.hh-buy__arrow--next');

        const data = this.querySelector('[data-hh-variants]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        this.idInput = this.querySelector('input[name="id"]');
        this.submit = this.querySelector('.hh-buy__submit');
        this.submitText = this.submit?.querySelector('span');
        this.priceNow = this.querySelector('[data-price-now]');
        this.priceWas = this.querySelector('[data-price-was]');
        this.save = this.querySelector('[data-save]');
        this.selectedName = this.querySelector('[data-selected-name]');
        this.low = this.querySelector('[data-low]');
        this.lowText = this.querySelector('[data-low-text]');

        this.setupGallery();
        this.setupVariants();
        this.setupQuantity();
        this.setupRating();
      }

      /* ---------- Gallery ---------- */
      setupGallery() {
        if (!this.track || this.slides.length === 0) return;

        this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.goTo(index)));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
        this.prev?.addEventListener('click', () => this.goTo(this.current - 1));
        this.next?.addEventListener('click', () => this.goTo(this.current + 1));

        this.current = 0;
        let ticking = false;
        this.track.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              ticking = false;
              const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
              this.setCurrent(index);
            });
          },
          { passive: true }
        );
        this.setCurrent(0);
      }

      goTo(index) {
        const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({ left: clamped * this.track.clientWidth });
        this.setCurrent(clamped);
      }

      setCurrent(index) {
        if (index === this.current && this.initialised) return;
        this.initialised = true;
        this.current = index;
        this.thumbs.forEach((el, i) => el.setAttribute('aria-current', i === index ? 'true' : 'false'));
        this.dots.forEach((el, i) => el.setAttribute('aria-current', i === index ? 'true' : 'false'));
        if (this.prev) this.prev.disabled = index === 0;
        if (this.next) this.next.disabled = index === this.slides.length - 1;
      }

      /* ---------- Variants ---------- */
      setupVariants() {
        this.querySelectorAll('.hh-buy__swatch input').forEach((input) => {
          input.addEventListener('change', () => this.selectVariant(Number(input.value)));
        });
      }

      selectVariant(id) {
        const variant = this.variants.find((v) => v.id === id);
        if (!variant) return;

        if (this.idInput) this.idInput.value = variant.id;
        if (this.selectedName) this.selectedName.textContent = variant.title;
        if (this.priceNow) this.priceNow.textContent = variant.price;
        if (this.priceWas) {
          this.priceWas.textContent = variant.compare || '';
          this.priceWas.hidden = !variant.compare;
        }
        if (this.save) {
          this.save.textContent = variant.save || '';
          this.save.hidden = !variant.save;
        }

        if (this.low && this.lowText) {
          const hasLow = typeof variant.low === 'number' && variant.low > 0;
          this.lowText.textContent = hasLow ? this.low.dataset.lowTemplate.replace('[count]', variant.low) : '';
          this.low.hidden = !hasLow;
        }

        if (this.submit) {
          if (variant.available) {
            this.submit.removeAttribute('disabled');
            if (this.submitText) this.submitText.textContent = this.submit.dataset.addLabel;
          } else {
            this.submit.setAttribute('disabled', 'disabled');
            if (this.submitText) this.submitText.textContent = this.submit.dataset.soldOutLabel;
          }
        }

        if (variant.media) {
          const slideIndex = this.slides.findIndex((slide) => slide.dataset.mediaId === String(variant.media));
          if (slideIndex > -1) this.goTo(slideIndex);
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      /* ---------- Quantity ---------- */
      setupRating() {
        const rating = this.querySelector('[data-hh-rating]');
        const summary = document.querySelector('.hh-reviews__summary[data-hh-rating]');
        if (!rating || !summary) return;
        const score = parseFloat(summary.dataset.hhRating);
        const count = parseInt(summary.dataset.hhCount, 10);
        if (!(score > 0) || !(count > 0)) return;

        const filled = Math.round(score);
        rating.querySelectorAll('.hh-buy__stars > span').forEach((star, i) => {
          star.classList.toggle('is-empty', i >= filled);
        });
        rating.querySelector('[data-hh-rating-score]').textContent = score.toFixed(1);
        rating.querySelector('[data-hh-rating-count]').textContent = `${count} review${count === 1 ? '' : 's'}`;
        rating.setAttribute('aria-label', `Rated ${score.toFixed(1)} out of 5 from ${count} review${count === 1 ? '' : 's'}`);
        const section = summary.closest('section[id]');
        if (section) rating.href = `#${section.id}`;
        rating.hidden = false;
      }

      setupQuantity() {
        const input = this.querySelector('.hh-buy__qty input');
        if (!input) return;
        this.querySelectorAll('.hh-buy__qty button').forEach((button) => {
          button.addEventListener('click', () => {
            const step = button.name === 'plus' ? 1 : -1;
            const value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
            input.value = value;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }
    }
  );
}
